import { createAction } from 'typesafe-actions';
import { IDamage } from '../../../types/model/masterData/damage';

export default class DamageActions {
    public static setLoading = createAction('MASTER_DATA_DAMAGE_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_DAMAGE_SET', resolve => (blocks : Array<IDamage>) => resolve(blocks));
}